import { Component, OnInit } from '@angular/core';
import { ProductModel } from 'src/app/model/selfcareproducts';
import { ProductService } from 'src/app/services/product.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { DataServiceService } from 'src/app/services/data-service.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-homeoffers',
  templateUrl: './homeoffers.component.html',
  styleUrls: ['./homeoffers.component.css']
})
export class HomeoffersComponent implements OnInit {

  OurOffers : ProductModel[];
  homedataplans : ProductModel[];
  aProduct: ProductModel;
  constructor(private productservise:ProductService,
    private authenticationService:AuthenticationService,
    private dataServiceService:DataServiceService, private router: Router) {

 
  
  // this. loadSelfcareproducts();
 
    
   }



   buyProductNow(productModel: ProductModel)
{
  this.aProduct = productModel;
// check if user is logged in

if (this.authenticationService.isLoggedIn()) 
{ 
  this.dataServiceService.changeProduct(productModel);
   this.router.navigate(['/cartcheckout']);
  
 }  
else{   // take user to product checkout

  this.router.navigate(['/checkout']);

}

}
   loadSelfcareproducts()
   {
   
   
     this.productservise.getSelfcareProducts().subscribe(    
       data => {    
         //    
         if(data.Status=="1")    
         {       
           
                //
            
        
         var products :  ProductModel[]= <ProductModel[]> data.Result;                 
         var displayProducts = products.filter(product => product.Display.ShowonSelfcare === true);
         
         displayProducts.forEach(x1 => x1.DisplayName = "₦" + x1.Price.toLocaleString() + " - " + x1.Name);
   
           this. OurOffers = products.filter(product => product.Display.CanRenew === false);
   
           this.homedataplans  = products.filter(product => product.Display.CanRenew === true);
   
         localStorage.setItem("displayProducts",JSON.stringify(displayProducts));
         localStorage.setItem("OurOffers",JSON.stringify(this.OurOffers));
   
         localStorage.setItem("homedataplans",JSON.stringify(this.homedataplans));
         
         }    
         else{   
        
           
           //    
         //  this.errorMessage = data.Message;    
         //  this.alertService.error(this.errorMessage);
         }    
       },     
       error => {    
          ; 
       
   
         //his.errorMessage = error.message; 
         
        // this.alertService.error(this.errorMessage); 
       });   
   
   
   }
  ngOnInit() {
  }

}
